export const messages = {
    please_connect: "Please connect your wallet to the Binance Smart network to use Safuu.",
    please_connect_wallet: "Please connect your wallet.",
    tx_successfully_send: "Your transaction was successfully sent",
    nothing_to_claim: "You have nothing to claim",
    something_wrong: "Something went wrong",
    switch_to_bsc: "Switch to the Binance Smart Chain network?",
};
